import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getClaudeCodeInstructions = (playground, bearerToken, mcpServerUrl) => `

${
  playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : ""
}Run the following command in your terminal to add this server to your Claude Code.

\`\`\`bash
claude mcp add --transport ${
  playground.mcpServerType === "HTTP_STREAM" ? "http" : "sse"
} \\
${sanitizeName(playground.name)} ${mcpServerUrl} ${
  playground.authType === "BEARER_TOKEN"
    ? `\\
    -H "Authorization: Bearer ${bearerToken ? bearerToken : "<YOUR_API_KEY>"}"`
    : ""
}
\`\`\`


For further details, see [the official documentation here](https://docs.anthropic.com/en/docs/claude-code/mcp).


`;

export default getClaudeCodeInstructions;
